import React, { useContext } from 'react'
import {Redirect, Route, RouteProps} from 'react-router'
import { AuthContext } from '../context/auth.context'

export interface IPrivateRouteProps extends RouteProps {
  redirectPath: string // redirect path if don't authenticate route
}

const PrivateRoute: React.FC<IPrivateRouteProps> = (props) => {
  const authContext = useContext(AuthContext);

  return authContext.isAuth ? (
    <Route {...props} component={props.component} render={undefined} />
  ) : (
    <Redirect to={{pathname: props.redirectPath}} />
  )
}

export default PrivateRoute